import React, { createRef } from "react";
import jet from "@randajan/jet-core";

import Home from "./Home/Home";
import Services from "./Services/Services";
import About from "./About/About";
import Pricelist from "./Pricelist/Pricelist";
import Calculator from "./Calculator/Calculator";
import { JoinUs } from "./JoinUs/JoinUs";
import E404 from "./E404/E404";
import { createRouter } from "@randajan/jet-react/dom/router";
import tab from "@randajan/jet-react/base/tab";
import { page } from "../config/base";
import { Gdpr } from "./Docs/Gdpr/Gdpr";
import { Terms } from "./Docs/Terms/Terms";
import { AppLink } from "./AppLink/AppLink";

export const Router = createRouter(
  { menuLabel:"úvod", path:"/", content:<Home/> },
  { menuLabel:"služby", title:"služby", path:"/services", content:<Services/> },
  { menuLabel:"o nás", title:"o nás", path:"/about", content:<About/> },
  { menuLabel:"ceník", title:"ceník", path:"/price/list", content:<Pricelist/> },
  { title:"Přidej se k nám!", path:"/joinUs", content:<JoinUs/> },
  { title:"Link", path:"/link", content:<AppLink/> },
  { title:"kalkulačka", path:"/price/calc", content:<Calculator/> },
  { title:"GDPR", path:"/docs/gdpr", content:<Gdpr/> },
  { title:"Servisní podmínky", path:"/docs/terms", content:<Terms/> },
  { title:"nenalezeno", path:"(.*)", content:<E404/> }
);

let _int;
tab.fitType("slept", "Number");

tab.fit((next, v)=>{
  v = Object.jet.tap(v);

  const route = Router.matchRoute(page.get("pathname"));
  v.title = jet.melt(["itcan", route.title], " > ");

  clearTimeout(_int);

  if (v.visible !== false) { v.slept = 0; v.title += " 😊"; }
  else {
    v.title += (" 😴" + "z".repeat(v.slept%4));
    _int = setTimeout(_=>tab.set("slept", v.slept + 1), 2000);
  }

  return v;
});

page.watch(_=>tab.set("title"));